import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取公告数据
export const getListData = (params) => {
  return axios.post(root+'/oa/inforlist/list', qs.stringify(params))
}

//获取公告明细
export const getDetail = (params) => {
  return axios.get(root+'/oa/inforlist/detail', {params:params})
}

//删除行
export const deleteData = (params) => {
  return axios.post(root+'/oa/inforlist/remove',  qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root+'/oa/inforlist/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/oa/inforlist/save', qs.stringify(params))
  }
}

//保存某一行的数据
export const saveLogData = (params) => {
    return axios.post(root+'/oa/inforvisitlog/save', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/api/oa/inforlist.js